/* global App */
import React, { Component } from "react";
import PropTypes from "prop-types";
import { Icon } from "semantic-ui-react";
import { CollectionResponse } from "active-resource";
import * as Sentry from "@sentry/react";
import fetchNotifications from "../../shared/notifications/fetchNotifications";
// eslint-disable-next-line import/no-named-as-default
import NotificationItems from "./NotificationItems";
import {
  NotificationsMenuWrapper,
  Counter,
} from "./styles/notifications-styles";
import trackEvent from "../../shared/ga/trackEvent";

class Notifications extends Component {
  constructor(props) {
    super(props);
    const {
      notificationsUrl,
      unreadNotifications,
      markAllNotificationsReadUrl,
    } = this.props;
    const notifications = CollectionResponse.build([]);
    this.state = {
      dropdownVisible: false,
      loading: false,
      markAllNotificationsReadUrl,
      notifications,
      notificationsUrl,
      unreadNotifications,
    };
  }

  componentDidMount() {
    document.addEventListener("click", this.hideVisibility);
    this.subscribeChannel();
  }

  componentWillUnmount() {
    document.removeEventListener("click", this.hideVisibility);
  }

  toggleVisibility = () => {
    const { dropdownVisible, notifications } = this.state;
    const newVisibilityState = !dropdownVisible;

    this.setState({ dropdownVisible: newVisibilityState });

    if (newVisibilityState && notifications.empty()) {
      trackEvent("Notification", "Opened Tray", "Opened Notifications Tray");
      this.setState({ loading: true });

      fetchNotifications(
        (notificationsCollectionResponse) => {
          this.setState({
            notifications: notificationsCollectionResponse,
            loading: false,
          });
        },
        (error) => {
          Sentry.captureException(error);
        }
      );
    } else if (newVisibilityState && !notifications.empty()) {
      trackEvent("Notification", "Opened Tray", "Opened Notifications Tray");
    }
  };

  hideVisibility = (e) => {
    if (e.target.id !== "notifications-trigger") {
      this.setState({ dropdownVisible: false });
    }
  };

  subscribeChannel() {
    App.cable.subscriptions.create(
      { channel: "NotificationsChannel" },
      {
        connected: () => {},
        disconnected: () => {},
        received: (data) => {
          fetchNotifications(
            (notificationsCollectionResponse) => {
              const { unreadNotifications } = JSON.parse(data);
              this.setState({
                notifications: notificationsCollectionResponse,
                unreadNotifications,
              });
            },
            (error) => {
              Sentry.captureException(error);
            }
          );
        },
      }
    );
  }

  render() {
    const {
      dropdownVisible,
      loading,
      markAllNotificationsReadUrl,
      notifications,
      notificationsUrl,
      unreadNotifications,
    } = this.state;

    return (
      <NotificationsMenuWrapper
        onClick={this.toggleVisibility}
        data-test-id="notifications-menu"
        className={`${dropdownVisible ? "active" : null}`}
      >
        <Icon
          name="bell"
          id="notifications-trigger"
          style={{
            color: `${unreadNotifications === 0 ? "#e0e0e0" : "#673490"}`,
          }}
        />
        <Counter
          id="unread-notifications"
          className={unreadNotifications === 0 && "hidden"}
          style={{
            display: `${unreadNotifications === 0 ? "none" : "block"}`,
          }}
        >
          {unreadNotifications}
        </Counter>
        <NotificationItems
          dropdownVisible={dropdownVisible}
          loading={loading}
          markAllNotificationsReadUrl={markAllNotificationsReadUrl}
          notifications={notifications}
          notificationsUrl={notificationsUrl}
        />
      </NotificationsMenuWrapper>
    );
  }
}

Notifications.propTypes = {
  notificationsUrl: PropTypes.string.isRequired,
  markAllNotificationsReadUrl: PropTypes.string.isRequired,
  unreadNotifications: PropTypes.number.isRequired,
};

export default Notifications;
